import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=1b90c1ff&lang=scss"
import "./index.vue?vue&type=style&index=1&id=1b90c1ff&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=2&id=1b90c1ff&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b90c1ff"]])

export default __exports__